export default "__VITE_ASSET__nKI8g7fX__"